<template>
    <div class="col-group">
         <TaxinummerLink date="Jan-Feb 2012" nummer="17" />
         <TaxinummerLink date="Februari-Maart 2012" nummer="18" />
         <TaxinummerLink date="Maart-April 2012" nummer="19" />
         <TaxinummerLink date="April-Mei 2012" nummer="20" />
         <TaxinummerLink date="Mei-Juni 2012" nummer="21" />
         <TaxinummerLink date="Juni-Juli 2012" nummer="22" />
         <TaxinummerLink date="Juli-Augustus 2012" nummer="23" />
         <TaxinummerLink date="Aug-September 2012" nummer="24" />
         <TaxinummerLink date="Sept-November 2012" nummer="25" />
         <TaxinummerLink date="Nov-December 2012" nummer="26" />
         <TaxinummerLink date="December-Jan 2012" nummer="27" />
    </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
  name: 'magazine-2012',
  components: {
      'TaxinummerLink': TaxinummerLink,
  }
}
</script>
